"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _action = require("../../../../../../components/notification/action");

var _action2 = require("./action");

var _MySecretList = _interopRequireDefault(require("./MySecretList"));

var _action3 = require("../../../../../../components/spinner-overlay/action");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$userSecretsRed = state.userSecretsReducer.allSecretsReducer.secretList,
      secretListData = _state$userSecretsRed.result,
      secretListPagination = _state$userSecretsRed.pagination,
      secretListLoading = _state$userSecretsRed.loading,
      secretSearchTerm = _state$userSecretsRed.searchTerm;
  var vaultId = state.vaultLanding.data.id;
  var _state$userSecretsRed2 = state.userSecretsReducer.allSecretsReducer.secretDetails,
      secretDetailStatus = _state$userSecretsRed2.status,
      secretDetailData = _state$userSecretsRed2.data,
      secretDetailError = _state$userSecretsRed2.error,
      secretDetailsLoadTime = _state$userSecretsRed2.loadingTime;
  var _state$userSecretsRed3 = state.userSecretsReducer.allSecretsReducer.secretTemplateDetails,
      secretTemplateDetailStatus = _state$userSecretsRed3.status,
      secretTemplateData = _state$userSecretsRed3.data,
      secretTemplateDetailError = _state$userSecretsRed3.error,
      secretTemplateLoadTime = _state$userSecretsRed3.loadingTime;
  var _state$userSecretsRed4 = state.userSecretsReducer.allSecretsReducer.secretFileDownload,
      secretDownloadedFile = _state$userSecretsRed4.data,
      secretFileDownloadStatus = _state$userSecretsRed4.status,
      secretFileDownloadStatusCode = _state$userSecretsRed4.statusCode,
      secretFileDownloadError = _state$userSecretsRed4.error;
  var _state$userSecretsRed5 = state.userSecretsReducer.allSecretsReducer.secretOTP,
      otp = _state$userSecretsRed5.otp,
      secretOTPFetchStatus = _state$userSecretsRed5.status,
      secretOTPFetchError = _state$userSecretsRed5.error,
      secretOTPFetchLoadTime = _state$userSecretsRed5.loadingTime;
  var _state$userSecretsRed6 = state.userSecretsReducer.allSecretsReducer.authenticateStepUpMFADetails,
      mfaAuthenticateStatus = _state$userSecretsRed6.status,
      mfaAuthenticate = _state$userSecretsRed6.data,
      mfaAuthenticateError = _state$userSecretsRed6.error;
  var _state$userSecretsRed7 = state.userSecretsReducer.allSecretsReducer.fetchUserMFAStatus,
      fetchUserMFAStatusStatus = _state$userSecretsRed7.status,
      fetchUserMFAStatusData = _state$userSecretsRed7.data;
  var _state$userSecretsRed8 = state.userSecretsReducer.allSecretsReducer.webAuthnAuthenticationInitialData,
      webAuthnAuthenticationInitialDataStatus = _state$userSecretsRed8.status,
      webAuthnAuthenticationInitialData = _state$userSecretsRed8.data;
  return {
    secretListLoading: secretListLoading,
    secretListData: secretListData,
    secretListPagination: secretListPagination,
    selectedItemAncestors: ownProps.selectedItemAncestors,
    vaultId: vaultId,
    secretDetailStatus: secretDetailStatus,
    secretDetailData: secretDetailData,
    secretTemplateDetailStatus: secretTemplateDetailStatus,
    secretTemplateDetailError: secretTemplateDetailError,
    secretTemplateData: secretTemplateData,
    secretSearchTerm: secretSearchTerm,
    secretDetailError: secretDetailError,
    secretDownloadedFile: secretDownloadedFile,
    secretFileDownloadStatus: secretFileDownloadStatus,
    secretFileDownloadStatusCode: secretFileDownloadStatusCode,
    secretFileDownloadError: secretFileDownloadError,
    otp: otp,
    secretOTPFetchStatus: secretOTPFetchStatus,
    secretOTPFetchError: secretOTPFetchError,
    secretDetailsLoadTime: secretDetailsLoadTime,
    secretTemplateLoadTime: secretTemplateLoadTime,
    secretOTPFetchLoadTime: secretOTPFetchLoadTime,
    mfaAuthenticateStatus: mfaAuthenticateStatus,
    mfaAuthenticate: mfaAuthenticate,
    mfaAuthenticateError: mfaAuthenticateError,
    fetchUserMFAStatusData: fetchUserMFAStatusData,
    fetchUserMFAStatusStatus: fetchUserMFAStatusStatus,
    webAuthnAuthenticationInitialDataStatus: webAuthnAuthenticationInitialDataStatus,
    webAuthnAuthenticationInitialData: webAuthnAuthenticationInitialData
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    getSecretList: function getSecretList(parents) {
      return dispatch((0, _action2.requestSecretList)(parents));
    },
    getSecretDetails: function getSecretDetails(path, data) {
      return dispatch((0, _action2.requestSecretDetails)(path, data));
    },
    getAuthenticateStepUpMFA: function getAuthenticateStepUpMFA(factor, postBody) {
      return dispatch((0, _action2.requestAuthenticateStepUpMFA)(factor, postBody));
    },
    flushStepUpMFA: function flushStepUpMFA() {
      return dispatch((0, _action2.flushStepUpMFA)());
    },
    openNotification: function openNotification(type, title, duration) {
      return dispatch((0, _action.openNotification)(type, title, true, duration));
    },
    getSecretLoadMoreList: function getSecretLoadMoreList(parents) {
      return dispatch((0, _action2.requestSecretListLoadMore)(parents));
    },
    updateSecretListSearchTerm: function updateSecretListSearchTerm(search) {
      return dispatch((0, _action2.updateSecretListSearchTerm)(search));
    },
    initSpinnerOverlay: function initSpinnerOverlay(data) {
      return dispatch((0, _action3.initSpinnerOverlay)(data));
    },
    resetSecretDetails: function resetSecretDetails() {
      return dispatch((0, _action2.resetSecretDetails)());
    },
    getSecretFile: function getSecretFile(parents, vaultId) {
      return dispatch((0, _action2.getSecretFileDownloadAction)(parents, vaultId));
    },
    fetchNewOTP: function fetchNewOTP(parents) {
      return dispatch((0, _action2.getNewOTPAction)(parents));
    },
    resetOTP: function resetOTP() {
      return dispatch((0, _action2.resetOTPAction)());
    },
    initiateWebAuthnAuthentication: function initiateWebAuthnAuthentication() {
      return dispatch((0, _action2.startWebAuthnAuthentication)());
    },
    getUserMFAStatus: function getUserMFAStatus() {
      return dispatch((0, _action2.fetchUserMFAStatus)());
    },
    authenticateWebAuthN: function authenticateWebAuthN(webAuthnInitialData, publicKeyCredential) {
      return dispatch((0, _action2.authenticateViaWebAuthN)(webAuthnInitialData, publicKeyCredential));
    },
    resetStartWebAuthnAuthentication: function resetStartWebAuthnAuthentication() {
      return dispatch((0, _action2.resetStartWebAuthnAuthentication)());
    },
    resetFetchUserMFAStatus: function resetFetchUserMFAStatus() {
      return dispatch((0, _action2.resetFetchUserMFAStatus)());
    }
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_MySecretList.default);

exports.default = _default;